var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { attr, FASTElement } from "@microsoft/fast-element";
import { Button as FabricButton } from "@fluentui/web-components";
/**
 * LoadingButton
 * @summary A custom button component with a loading state that extends Fluent UI's Button class. It provides visual feedback with a spinner when the button is in a loading state and disables interaction.
 *
 * @example
 * ```html
 * <fabric-loading-button
 *   appearance='primary'
 *   size='large'
 *   shape='rounded'
 *   loading
 *   disabled
 *   aria-busy='true'>
 *   Submit
 * </fabric-loading-button>
 * ```
 *
 * @attr {boolean} loading - Indicates whether the button is in a loading state.
 * @attr {ButtonAppearance} appearance - The appearance of the button.
 * @attr {ButtonShape} shape - The shape of the button.
 * @attr {ButtonSize} size - The size of the button.
 * @attr {string} aria-busy - Indicates whether the button is busy.
 *
 * @prop {boolean} loading - Indicates whether the button is in a loading state. Default: false.
 * @prop {boolean} disabled - Indicates whether the button is disabled. Default: false.
 *
 * @slot - The default slot for the button content.
 * @slot start - Slot for the spinner when the button is loading.
 *
 * @csspart control - The control part of the button, styled differently when loading and disabled.
 *
 * @extends FluentButton
 * @tagname fabric-loading-button
 * @public
 */
export class LoadingButton extends FabricButton {
    constructor() {
        super(...arguments);
        /**
         * Indicates whether the button is in a loading state.
         * @public
         * @type {boolean}
         * @default false
         */
        this.loading = false;
    }
}
__decorate([
    attr({ mode: "boolean" })
], LoadingButton.prototype, "loading", void 0);
//# sourceMappingURL=loading-button.js.map